import React from "react";

const IconPDF = ({ color = "#e31c19" }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M605 5110 c-11 -4 -31 -20 -45 -35 l-25 -27 0 -2489 0 -2489 33 -32
32 -33 1960 0 1960 0 32 33 33 32 3 2063 c1 1134 0 2073 -3 2087 -8 33 -838
867 -882 886 -27 12 -273 14 -1555 13 -838 0 -1532 -4 -1543 -9z m2933 -312
l-3 -83 -1382 -3 -1383 -2 0 85 0 85 1385 0 1386 0 -3 -82z m442 -293 l195
-195 -198 0 -197 0 0 195 c0 107 1 195 3 195 1 0 90 -88 197 -195z m-440 -190
c0 -169 7 -198 54 -229 22 -14 68 -16 391 -16 l365 0 0 -1915 0 -1915 -1790 0
-1790 0 0 2115 0 2115 1385 0 1385 0 0 -155z"
        />
        <path
          d="M2515 4180 c-87 -35 -132 -204 -106 -391 7 -46 33 -146 58 -223 l46
-138 -18 -57 c-36 -115 -153 -382 -260 -595 l-110 -219 -115 -47 c-294 -119
-493 -259 -560 -392 -33 -68 -36 -93 -16 -142 37 -88 180 -86 330 4 99 60 288
260 441 466 l60 81 135 36 c158 42 353 80 498 97 l103 12 47 -39 c164 -137
344 -217 539 -238 227 -25 338 140 170 252 -107 71 -288 104 -562 102 l-190
-2 -58 69 c-83 99 -164 221 -242 362 l-67 122 15 63 c80 316 51 734 -56 801
-32 20 -59 26 -82 16z m50 -93 c8 -14 20 -71 27 -130 10 -90 9 -122 -5 -219
-9 -63 -23 -134 -30 -158 l-13 -45 -22 65 c-65 194 -68 393 -8 486 20 30 31
30 51 1z m94 -962 c53 -95 137 -220 212 -312 33 -39 59 -74 59 -76 0 -3 -30
-8 -67 -12 -122 -12 -404 -68 -516 -101 -14 -4 -9 8 18 51 57 89 168 312 200
400 16 44 32 90 36 103 5 12 10 22 13 22 2 0 23 -34 45 -75z m856 -472 c76
-21 184 -74 210 -103 8 -9 13 -24 10 -33 -12 -30 -66 -42 -185 -42 -106 1
-122 4 -196 33 -85 34 -184 93 -243 145 l-35 30 185 -6 c139 -3 201 -9 254
-24z m-1551 -339 c-146 -209 -258 -309 -367 -329 -48 -9 -84 0 -97 25 -27 51
74 174 228 277 78 52 311 167 320 158 2 -2 -36 -61 -84 -131z"
        />
        <path
          d="M1600 976 l0 -386 105 0 105 0 0 129 0 128 83 6 c124 8 196 47 239
131 26 50 35 154 19 214 -14 52 -60 106 -115 135 -37 20 -59 22 -238 25 l-198
4 0 -386z m293 213 c45 -12 62 -42 53 -93 -9 -46 -47 -76 -97 -76 l-39 0 0 90
c0 101 1 102 83 79z"
        />
        <path
          d="M2282 978 l3 -383 120 -3 c286 -7 427 52 496 208 32 72 45 187 31
270 -22 130 -78 206 -192 259 -53 25 -64 26 -258 29 l-202 4 2 -384z m363 194
c16 -10 40 -38 53 -62 20 -39 23 -57 20 -135 -5 -139 -37 -185 -142 -207 -90
-18 -86 -28 -86 210 0 115 3 212 8 216 11 13 113 -3 147 -22z"
        />
        <path
          d="M3080 975 l0 -385 100 0 100 0 0 145 0 144 118 3 117 3 3 83 3 82
-121 0 -121 0 3 73 3 72 123 3 122 3 0 79 0 80 -225 0 -225 0 0 -385z"
        />
      </g>
    </svg>
  );
};

export default IconPDF;
